import React, { useEffect } from "react";
import sadIcon from "../../assets/images/emojiiSad.png";
import { useHistory } from "react-router-dom";

const NoResultPage = ({ text }) => {
  const history = useHistory();

  useEffect(() => {
    const timer = setTimeout(() => {
      history.goBack(); 
    }, 5000);

    return () => clearTimeout(timer);
  }, [history]);

  return (
    <div className="thankyou-page">
    <div className="thankyou-page-content">
      <img
        src={sadIcon}
        alt="Sad Icon"
        className="course-result-emojii"
      />
      <div className="thankyou-text">
        {text}
      </div>
    </div>
  </div>
  );
};

export default NoResultPage;